export const AB_API_HOSTS = {
	local_development: 'https://dev-api.aofl.com',
	development: 'https://dev-api.aofl.com',
	staging: 'https://api.aofl.com',
	production: 'https://api.aofl.com',
};

export const DEVICE_KEY_MAP = {
	acquisition_source: 'acquisitionSource',
	device_id: 'deviceId',
	localeCode: 'localeCode',
	is_first_time_visit: 'isFirstTimeVisit',
	app_version: 'appVersion',
	country_code: 'viewerCountry',
	is_mobile_viewer: 'isMobileViewer',
	is_desktop_viewer: 'isDesktopViewer',
	is_webview: 'inApp',
	app_store: 'appStore',
	browser_platform: 'browserPlatform',
	// is_ios_viewer: 'isIosViewer',
	is_link_from_app: 'isLinkFromApp',
	is_link_from_app_platform: 'isLinkFromAppPlatform',
	is_aofl_product_uuid: 'isEmailLinkClick',
	is_link_from_email: 'isLinkFromEmail',
	is_automated_testing: 'isAutomatedTesting',
};

export const ACTIVE_EXPERIMENTS = {
	ABCM2_MAX_TIER_OFFER: {
		experimentKey: 'subscription-tier-max',
		variants: {
			test: 'test-a',
			test_b: 'test-b',
			control: 'default',
		},
	},
	PAYPAL_APP_SWITCH: {
		experimentKey: 'paypal-app-switch',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_SIMPLIFY_BROWSER_REACTIVATIONS: {
		experimentKey: 'simplify-browser-reactivations',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_UPGRADE_PAGE_REDESIGN: {
		experimentKey: 'upgrade-page-redesign',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_LOGIN_PAGE_CONDITION: {
		experimentKey: 'refactor-experiment-client-aa',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_TUTOR_OFFER: {
		experimentKey: 'onboarding-tutor-upsell',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_SIMPLIFY_1_0_IOS_ALT_REACTIVATIONS: {
		experimentKey: 'simplify-1-0-ios-alt-reactivations',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_SIMPLIFY_ANDROID_ALT_REACTIVATIONS: {
		experimentKey: 'simplify-android-alt-reactivations',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_DIRECT_ANNUAL_PRICE: {
		experimentKey: 'direct-annual-price',
		variants: {
			test_a: 'test a',
			test_b: 'test b',
			test_c: 'test c',
			control: 'default',
		},
	},
	ABCM2_AA_OFFER_REDESIGN: {
		experimentKey: 'browser-academy-upsell-redesign',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_PRE_PAID_CARDS_V2: {
		experimentKey: 'decline-prepaid-cards-v2',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_FAMILY_VACATION_GIVEAWAY: {
		experimentKey: 'family-vacation-giveaway',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_PRE_PAID_CARDS_V4: {
		experimentKey: 'decline-prepaid-cards-v4',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_ANNUAL_ASSESSMENTS_BILLED_NOW: {
		experimentKey: 'annual-assessments-billed-now',
		variants: {
			test_a: 'test-a',
			test_b: 'test-b',
			control: 'default',
		},
	},
	ABCM2_ROKT: {
		experimentKey: 'browser-so-rokt-create-account-product-info',
		variants: {
			test_a: 'test a',
			test_b: 'test b',
			control: 'default',
		},
		offerHashByVariant: {
			'test a': '2kt9wrn',
			'test b': '2kt9vvn',
			'default': '123br4nd',
		},
	},
};

export const PROFILE = 'abcmouse';

export const EXPERIMENT_KEYS = [
	ACTIVE_EXPERIMENTS.ABCM2_MAX_TIER_OFFER.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_SIMPLIFY_BROWSER_REACTIVATIONS.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_SIMPLIFY_1_0_IOS_ALT_REACTIVATIONS.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_SIMPLIFY_ANDROID_ALT_REACTIVATIONS.experimentKey,
];

export const DATA_TYPES = {
	DEVICE: 'device',
	USER: 'user',
	SESSION: 'session',
	MASTER: 'master',
};

export const DATA_KEYS = {
	REACTIVATED_USER: 'is_reactivated_user',
	SPECIAL_OFFER_USER: 'is_special_offer_user',
	SUBSCRIPTION_STATUS: 'subscription_status',
	USER_SUBSCRIPTION_TYPE: 'user_subscription_type',
};
